import { BacksplashModelNumber } from './Enums';

export class BacksplashState {
  /**
   * Whether a backsplash is selected or not
   * @type {boolean}
   */
  isSelected = false;

  /**
   * The model number of the backsplash
   * @type {string}
   */
  modelNumber = BacksplashModelNumber.LCHD1400;

  /**
   * Is this hood created from a configuration URL?
   * @type {boolean}
   */
  isConfigured = false;

  /**
   * Set up the state of the backsplash from a previously configured backsplash
   *
   * @param {object} configuredBacksplash
   * @param {string} configuredBacksplash.modelNumber
   */
  setState(configuredBacksplash) {
    this.isConfigured = true;
    this.isSelected = true;

    if (
      Object.values(BacksplashModelNumber).includes(
        configuredBacksplash.modelNumber
      )
    ) {
      this.modelNumber = configuredBacksplash.modelNumber;
    } else {
      this.modelNumber = BacksplashModelNumber.LCHD1400;
    }
  }

  /**
   * The slug for a fully configured backsplash.
   * @returns {string}
   */
  slug() {
    return this.modelNumber;
  }
}
